/*
 * /gims-test — подготовка к аттестации судоводителя маломерного судна.
 *
 * Два режима: экзамен (билет с ограничением ошибок и временем) и разбор по
 * темам. Отличие от всех известных нам тренажёров одно и существенное: к
 * КАЖДОМУ вопросу есть разбор — почему верен именно этот ответ. Тренажёр,
 * который показывает только «правильно/неправильно», учит запоминать номера,
 * а не понимать, и на воде это не помогает.
 */

import { QUESTIONS, TOPICS, BLOCKS, TICKET, byTopic, topicCounts, makeExam, makeTicket } from './bank.js';
import { loadOfficial, officialReady, renderOfficial, renderOfficialRail } from './official.js';
import { makeT } from '../maritime/i18n.js';

const B = window.__GIMS || { T: {}, cfg: {} };
const T = B.T;
const t = makeT(T);
const $ = id => document.getElementById(id);
const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };

const S = {
    mode: 'exam',
    exam: null,
    idx: 0,
    answers: [],
    skill: {},
    topics: [],
    size: 20,
    allowed: TICKET.allowed,
    preset: 'ticket',
    timerEnd: 0,
    timerId: 0,
};

/* ── память о слабых местах ──────────────────────────────────────────────── */
function loadSkill() {
    try {
        const v = window.__toolSettings?.load('gims-test', 'skill', null);
        S.skill = v && typeof v === 'object' ? v : {};
    } catch { S.skill = {}; }
}
function saveSkill() {
    try { window.__toolSettings?.save('gims-test', 'skill', S.skill); } catch { /* приватный режим */ }
}
function note(id, right) {
    const s = S.skill[id] || (S.skill[id] = { seen: 0, wrong: 0 });
    s.seen++;
    if (!right) s.wrong++;
    else s.wrong = Math.max(0, s.wrong - 1);
}

/* ── экзамен ─────────────────────────────────────────────────────────────── */
function startExam() {
    /* Билет по приказу № 90 собирается из двух блоков (15 по судну + 10 по
       району), свой набор — как раньше, по выбранным темам. Разница не
       косметическая: настоящий экзамен идёт именно так, и тренироваться
       случайной выборкой из всех тем значит привыкать к другому ритму. */
    if (S.preset === 'ticket') {
        S.exam = makeTicket({ skill: S.skill });
        S.allowed = TICKET.allowed;
    } else {
        S.exam = makeExam(S.size, { topics: S.topics, skill: S.skill });
    }
    S.idx = 0;
    S.answers = new Array(S.exam.length).fill(null);
    S.timerEnd = Date.now() + S.exam.length * TICKET.minutesPerQuestion * 60 * 1000;
    clearInterval(S.timerId);
    tick();                                            // иначе первую секунду поле пустое
    S.timerId = setInterval(tick, 1000);
    $('gmIdle').hidden = true;
    $('gmExam').hidden = false;
    $('gmResult').hidden = true;
    renderQuestion();
    window.__stage?.('exam_started');
}

/** К какому блоку билета относится тема. */
function blockOf(topic) {
    return BLOCKS.vessel.includes(topic) ? 'vessel' : 'area';
}

function tick() {
    const left = Math.max(0, S.timerEnd - Date.now());
    // ⚠️ Часы собираются В КОДЕ, а не шаблоном перевода. Шаблон `:m:s` печатал
    //    «1958» вместо «19:58» (замерено на живой странице): двоеточие-
    //    разделитель — это собственное двоеточие плейсхолдера `:s`, и никакое
    //    переименование этого не чинит. Переводить в mm:ss нечего.
    $('gmTimer').textContent =
        String(Math.floor(left / 60000)).padStart(2, '0') + ':' +
        String(Math.floor((left % 60000) / 1000)).padStart(2, '0');
    if (left <= 0) { clearInterval(S.timerId); finishExam(); }
}

function renderQuestion() {
    const q = S.exam[S.idx];
    $('gmProgress').textContent = t('progress', { n: S.idx + 1, total: S.exam.length });
    $('gmTopic').textContent = t('topic_' + q.topic);
    $('gmQ').textContent = q.q;

    const box = $('gmAnswers');
    box.textContent = '';
    q.options.forEach((opt, i) => {
        const b = el('button', 'gm-ans');
        b.type = 'button';
        // Цифра, а не буква: она же и клавиша (1–4), и не зависит от локали.
        b.append(el('span', 'gm-ans-n', String(i + 1)));
        b.append(el('span', null, opt));
        const given = S.answers[S.idx];
        if (given !== null) {
            b.disabled = true;
            if (i === q.correctIndex) b.classList.add('ok');
            else if (i === given) b.classList.add('no');
            else b.classList.add('dim');
        } else {
            b.addEventListener('click', () => answer(i));
        }
        box.append(b);
    });

    const why = $('gmWhy');
    if (S.answers[S.idx] !== null) {
        why.hidden = false;
        why.textContent = '';
        why.className = 'gm-why ' + (S.answers[S.idx] === q.correctIndex ? 'ok' : 'no');
        why.append(el('div', 'gm-why-h', S.answers[S.idx] === q.correctIndex ? t('right') : t('wrong')));
        why.append(el('p', null, q.why));
    } else why.hidden = true;

    $('gmPrev').disabled = S.idx === 0;
    $('gmNext').textContent = S.idx === S.exam.length - 1 ? t('finish') : t('next');
    renderDots();
}

function renderDots() {
    const d = $('gmDots');
    d.textContent = '';
    S.exam.forEach((q, i) => {
        const b = el('button', 'gm-dot');
        b.type = 'button';
        b.textContent = String(i + 1);
        if (S.answers[i] !== null) b.classList.add(S.answers[i] === q.correctIndex ? 'ok' : 'no');
        if (i === S.idx) b.classList.add('cur');
        b.addEventListener('click', () => { S.idx = i; renderQuestion(); });
        d.append(b);
    });
}

function answer(i) {
    if (S.answers[S.idx] !== null) return;
    S.answers[S.idx] = i;
    const q = S.exam[S.idx];
    note(q.id, i === q.correctIndex);
    saveSkill();
    renderQuestion();
    window.__aeFunnel?.('answer', { topic: q.topic, correct: i === q.correctIndex });
}

function finishExam() {
    clearInterval(S.timerId);
    // ⚠️ Неотвеченный вопрос считается ошибкой в счёте — значит, он обязан
    //    попасть и в ПАМЯТЬ, иначе главное обещание тула («проваленное
    //    возвращается») не выполняется ровно для тех вопросов, на которых
    //    человек встал: кончилось время или он не знал, что выбрать.
    let noted = false;
    S.exam.forEach((q, i) => { if (S.answers[i] === null) { note(q.id, false); noted = true; } });
    if (noted) saveSkill();

    const wrong = S.exam.filter((q, i) => S.answers[i] !== q.correctIndex);
    const answered = S.answers.filter(a => a !== null).length;
    const passed = wrong.length <= S.allowed && answered === S.exam.length;

    $('gmExam').hidden = true;
    $('gmResult').hidden = false;
    const box = $('gmResult');
    box.textContent = '';
    box.className = 'tc-panel gm-result ' + (passed ? 'ok' : 'no');
    box.append(el('div', 'gm-res-h', passed ? t('res_pass') : t('res_fail')));
    box.append(el('div', 'gm-res-s', t('res_score', {
        right: S.exam.length - wrong.length, total: S.exam.length,
        wrong: wrong.length, allowed: S.allowed,
    })));

    /* Разбивка по блокам билета: на экзамене они считаются отдельно, и
       «пять ошибок, все в правилах» — это другой диагноз, чем «пять ошибок
       вразброс». */
    if (S.preset === 'ticket') {
        const per = { vessel: { n: 0, bad: 0 }, area: { n: 0, bad: 0 } };
        S.exam.forEach((q, i) => {
            const b = per[blockOf(q.topic)];
            b.n++;
            if (S.answers[i] !== q.correctIndex) b.bad++;
        });
        const row = el('div', 'tc-stats');
        for (const key of ['vessel', 'area']) {
            const d = el('div', 'tc-stat' + (per[key].bad ? ' warn' : ' good'));
            d.append(el('div', 'tc-stat-l', t('block_' + key)));
            d.append(el('div', 'tc-stat-v', (per[key].n - per[key].bad) + '/' + per[key].n));
            row.append(d);
        }
        box.append(row);
    }

    // Разбор ошибок по темам — это и есть ответ на вопрос «что учить».
    if (wrong.length) {
        const byT = {};
        for (const q of wrong) (byT[q.topic] ||= []).push(q);
        box.append(el('div', 'gm-sub', t('res_weak')));
        for (const [topic, list] of Object.entries(byT).sort((a, b) => b[1].length - a[1].length)) {
            const row = el('div', 'gm-weakrow');
            row.append(el('span', 'gm-weak-t', t('topic_' + topic)));
            row.append(el('span', 'gm-weak-n', t('res_weak_n', { n: list.length })));
            const go = el('button', 'gm-link');
            go.type = 'button';
            go.textContent = t('res_study');
            go.addEventListener('click', () => { S.topics = [topic]; setMode('study'); renderStudy(); });
            row.append(go);
            box.append(row);
        }
        box.append(el('div', 'gm-sub', t('res_mistakes')));
        for (const q of wrong) {
            const d = el('details', 'gm-mistake');
            d.append(el('summary', null, q.q));
            d.append(el('p', 'gm-correct', t('res_correct', { a: q.a[q.correct] })));
            d.append(el('p', 'gm-whytext', q.why));
            box.append(d);
        }
    }

    const again = el('button', 'tc-btn');
    again.type = 'button';
    again.textContent = t('again');
    again.addEventListener('click', startExam);
    box.append(again);
    window.__aeToolComplete?.({ passed, wrong: wrong.length, total: S.exam.length });
}

/* ── разбор по темам ─────────────────────────────────────────────────────── */
function renderStudy() {
    const list = $('gmStudy');
    list.textContent = '';
    const counts = topicCounts();
    const topics = S.topics.length ? S.topics : Object.keys(TOPICS);
    for (const topic of topics) {
        const sec = el('div', 'gm-topic');
        const head = el('div', 'gm-topic-h');
        head.append(el('span', null, t('topic_' + topic)));
        head.append(el('span', 'gm-topic-n', String(counts[topic] || 0)));
        sec.append(head);
        for (const q of byTopic(topic)) {
            const d = el('details', 'gm-card2');
            const s = el('summary');
            s.append(el('span', null, q.q));
            const sk = S.skill[q.id];
            if (sk?.wrong) s.append(el('span', 'gm-badge', t('was_wrong', { n: sk.wrong })));
            d.append(s);
            const ul = el('ul', 'gm-opts');
            q.a.forEach((opt, i) => {
                const li = el('li', i === q.correct ? 'correct' : '');
                li.textContent = opt;
                ul.append(li);
            });
            d.append(ul);
            d.append(el('p', 'gm-whytext', q.why));
            sec.append(d);
        }
        list.append(sec);
    }
}

/* ── настройки ───────────────────────────────────────────────────────────── */
function renderTopicPicker() {
    const box = $('gmTopics');
    box.textContent = '';
    const counts = topicCounts();
    for (const topic of Object.keys(TOPICS)) {
        const lab = el('label', 'gm-topicpick');
        const cb = el('input');
        cb.type = 'checkbox'; cb.value = topic; cb.checked = true;
        cb.addEventListener('change', () => {
            S.topics = [...box.querySelectorAll('input:checked')].map(x => x.value);
            updateSize();
        });
        lab.append(cb, el('span', null, t('topic_' + topic)), el('span', 'gm-topic-n', String(counts[topic] || 0)));
        box.append(lab);
    }
    S.topics = Object.keys(TOPICS);
}

function updateSize() {
    const avail = S.topics.length
        ? QUESTIONS.filter(q => S.topics.includes(q.topic)).length
        : QUESTIONS.length;
    const sel = $('gmSize');
    S.size = Math.min(Number(sel.value) || 20, avail);
    if (S.preset === 'ticket') {
        const v = QUESTIONS.filter(q => BLOCKS.vessel.includes(q.topic)).length;
        const a = QUESTIONS.filter(q => BLOCKS.area.includes(q.topic)).length;
        $('gmAvail').textContent = t('ticket_made', {
            v: Math.min(TICKET.vessel, v), a: Math.min(TICKET.area, a),
        });
        $('gmStartBtn').disabled = false;
    } else {
        $('gmAvail').textContent = t('available', { n: avail });
        $('gmStartBtn').disabled = avail < 5;
    }
}

function applyPreset() {
    const custom = S.preset === 'custom';
    $('gmCustom').hidden = !custom;
    $('gmTicketInfo').hidden = custom;
    updateSize();
}

function setMode(m) {
    S.mode = m;
    for (const b of document.querySelectorAll('.gm-tab')) b.classList.toggle('on', b.dataset.mode === m);
    for (const p of document.querySelectorAll('.gm-pane')) p.hidden = p.dataset.mode !== m;
    // Настройка билета относится только к режиму экзамена: в остальных она
    // занимала бы рейку органами, которые ни на что не влияют.
    const setup = $('gmSetup');
    if (setup) setup.hidden = m !== 'exam';
    if (m === 'study') renderStudy();
    if (m === 'official') showOfficial();
    window.__stage?.('mode_' + m);
}

/**
 * Официальный перечень МЧС. Грузится ЛЕНИВО (328 КБ, 62 КБ в gzip): человек,
 * пришедший прорешать наш билет, не должен платить за него трафиком.
 */
let officialFailed = false;
async function showOfficial() {
    const stage = $('gmOfficial'), rail = $('gmOfficialRail');
    if (!stage) return;
    if (!officialReady()) {
        stage.textContent = '';
        stage.append(el('div', 'tc-panel', t('off_loading')));
        try {
            await loadOfficial();
            officialFailed = false;
        } catch (e) {
            officialFailed = true;
            stage.textContent = '';
            const p = el('div', 'tc-panel');
            p.append(el('p', 'tc-title', t('off_error')), el('p', 'tc-hint', t('off_error_hint')));
            stage.append(p);
            window.__handleError?.(e, 'gims-official');
            return;
        }
    }
    if (officialFailed) return;
    const redraw = () => { renderOfficialRail(rail, redraw); renderOfficial(stage, redraw); };
    redraw();
}

function bind() {
    for (const b of document.querySelectorAll('.gm-tab')) b.addEventListener('click', () => setMode(b.dataset.mode));
    $('gmStartBtn').addEventListener('click', startExam);
    $('gmPreset').addEventListener('change', e => { S.preset = e.target.value; applyPreset(); });
    $('gmSize').addEventListener('change', updateSize);
    $('gmAllowed').addEventListener('change', e => { S.allowed = Number(e.target.value) || 3; });
    $('gmPrev').addEventListener('click', () => { if (S.idx > 0) { S.idx--; renderQuestion(); } });
    $('gmNext').addEventListener('click', () => {
        if (S.idx < S.exam.length - 1) { S.idx++; renderQuestion(); }
        else finishExam();
    });
    $('gmStop').addEventListener('click', finishExam);
    document.addEventListener('keydown', e => {
        if (S.mode !== 'exam' || $('gmExam').hidden) return;
        if (window.__keyOwnedByFocus ? window.__keyOwnedByFocus(e) : (e.target.matches('input,select,textarea'))) return;
        const q = S.exam?.[S.idx];
        if (!q) return;
        const kd = window.__keyLetter ? window.__keyLetter(e) : e.key;
        if (S.answers[S.idx] === null && /^[1-4]$/.test(kd) && !e.ctrlKey && !e.metaKey && !e.altKey) {
            const b = $('gmAnswers').children[Number(kd) - 1];
            if (b) { b.click(); e.preventDefault(); }
        } else if (e.key === 'Enter' || e.key === ' ') { $('gmNext').click(); e.preventDefault(); }
    });
}

function boot() {
    try {
        loadSkill();
        bind();
        renderTopicPicker();
        applyPreset();
        $('gmTotal').textContent = t('bank_total', { n: QUESTIONS.length, topics: Object.keys(TOPICS).length });
        setMode('exam');
        window.__stage?.('ready');
    } catch (err) {
        window.__handleError?.(err, 'gims-test');
        const b = $('gmTotal');
        if (b) b.textContent = t('load_error');
    }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
